import { KeyRound, MoreHorizontal, Pencil, Power, PowerOff, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { WebhookEndpoint } from '@nucleus-commerce/api-client/admin';
import { Button } from '@nucleus-commerce/ui/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@nucleus-commerce/ui/components/dropdown-menu';

export type EndpointAction = 'edit' | 'toggle' | 'rotate' | 'delete';

export interface EndpointActionsMenuProps {
  endpoint: WebhookEndpoint;
  onAction: (action: EndpointAction, endpoint: WebhookEndpoint) => void;
  disabled?: boolean;
}

export function EndpointActionsMenu({ endpoint, onAction, disabled }: EndpointActionsMenuProps) {
  const { t } = useTranslation('webhooks');
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          data-tour="settings.webhook.actions"
          variant="ghost"
          size="icon-sm"
          disabled={disabled}
          aria-label={t('actions.menu', { url: endpoint.url })}
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuItem onSelect={() => onAction('edit', endpoint)}>
          <Pencil aria-hidden />
          {t('actions.edit')}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onAction('toggle', endpoint)}>
          {endpoint.status === 'active' ? <PowerOff aria-hidden /> : <Power aria-hidden />}
          {endpoint.status === 'active' ? t('actions.disable') : t('actions.enable')}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onAction('rotate', endpoint)}>
          <KeyRound aria-hidden />
          {t('actions.rotate')}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem variant="destructive" onSelect={() => onAction('delete', endpoint)}>
          <Trash2 aria-hidden />
          {t('actions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
